module.exports = __webpack_public_path__ + "static/media/F-3.5956c0e8.webp";